import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Box, FormGroup } from '@mui/material'
import { styled } from '@mui/material'
import { createBlankMonitorCreateViewResource } from 'domain/monitor'
import { createMonitorCreateFromMonitorCreateView } from 'domain/monitor'
import { useCreateMonitorMutation } from 'services/monitor'
import type { MonitorCreateResource } from 'shared/types'
import type { MonitorCreateViewResource } from 'shared/types'
import { useAppDispatch } from 'shared/hooks'
import { setMainBarSettings, setParentUrl } from 'store/applicationSlice'
import { MonitorCreateFormView } from 'features/marketSpy/marketSpyCreate/ui/MonitorCreateFormView'

const Container = styled(FormGroup)``;

export const MonitorCreatePage = (): JSX.Element => {
    const navigate = useNavigate()
    const [createMonitor] = useCreateMonitorMutation()
    const [monitor] = useState<MonitorCreateViewResource>(createBlankMonitorCreateViewResource())
    const dispatch = useAppDispatch()

    const createMonitorHandler = async (monitor: MonitorCreateResource) => {
        return await createMonitor({
            monitor: monitor
        })
    }

    useEffect(() => {
        dispatch(setMainBarSettings({
            back: {
                url: '/market'
            },
            title: 'Create Market Spies'
        }))
        dispatch(setParentUrl(`/market`))

        return () => {
            dispatch(setMainBarSettings(undefined))
            dispatch(setParentUrl(undefined))
        }
    });

    const onMonitorCreateViewSubmitHandler = async ({ event, value }: any) => {
        const monitor: MonitorCreateResource = createMonitorCreateFromMonitorCreateView(value);
        const createMonitorResult: any = await createMonitorHandler(monitor);
        navigate(`/spy/${createMonitorResult?.data?.id}/monitorrun`);
    }

	return (
		<>
            <Container sx={
                {
                    width: {
                        md: '50%'
                    },
                    margin: {
                        md: '5% 0 0 25%'
                    },
                }
            }>
                <Box sx={{padding: '20px'} }>
                <MonitorCreateFormView
                    onSubmit={onMonitorCreateViewSubmitHandler}
                    value={monitor}
                    />
                </Box>
            </Container>
		</>
	);
}
